var _defs, _ellipse, _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path23, _path24, _path25, _path26, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path27, _polygon2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NoTemplates",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 832.63 548.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#96d9f2;}.cls-2{fill:#2184b0;}.cls-3{fill:#2baae2;}.cls-4{fill:#fece9a;}.cls-5{fill:#144d66;}.cls-6{fill:#e4f0fa;}.cls-7{fill:#fbb16d;}.cls-10,.cls-8{fill:none;stroke-miterlimit:10;stroke-width:6px;}.cls-8{stroke:#1a8fce;}.cls-9{fill:#1f6c8e;}.cls-10{stroke:#397dc0;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 397.34,
    cy: 504.41,
    rx: 397.34,
    ry: 43.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3670.61,6042.83h-99.18c-.27-15.17-.31-37.57,1.05-64.77,2.59-51.76,7.2-60.2,13.05-66,17.66-17.5,54.13-18.31,71.36-1.54,7.13,6.95,9.89,15.85,12.28,46.81A719.22,719.22,0,0,1,3670.61,6042.83Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3564.06,
    y: 6039.36,
    width: 56.29,
    height: 243.59,
    transform: "matrix(1, 0.07, -0.07, 1, -2975.36, -6075.15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3619.44,
    y: 6014.13,
    width: 73.49,
    height: 260.13,
    transform: "translate(-4681.41 -4889.17) rotate(-12.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3643.7,6079.53c1.42-8.05,17-15,28.11-9.41,10.14,5.06,14.26,18.81,9.41,28.11-3.72,7.12-12.91,12-18.62,9.71-3.58-1.46-3.15-4.71-8.62-13.36C3647.41,6084.2,3643,6083.2,3643.7,6079.53Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3673.86,
    y: 6097,
    width: 11.18,
    height: 34.94,
    rx: 4.14,
    transform: "translate(3720.82 6517.43) rotate(-178.11)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3676.71,
    y: 6086.04,
    width: 11.57,
    height: 34.94,
    rx: 4.29,
    transform: "translate(5167.04 5432.99) rotate(167.46)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3666.45,
    y: 6104.58,
    width: 11.18,
    height: 21,
    rx: 4.14,
    transform: "translate(3099 6819.42) rotate(-172.67)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3657.01,
    y: 6100.78,
    width: 11.18,
    height: 14.31,
    rx: 4.14,
    transform: "translate(3081.1 6803.99) rotate(-172.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3707.94,6323.73l-47,2.6-.38-42.52,40.65-2.24a123,123,0,0,1,3.8,13.59A128.16,128.16,0,0,1,3707.94,6323.73Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3732.65,6340.45l-70.72,3.91-1.17-37.82a407.7,407.7,0,0,1,47.15,11.86q6.26,2,12.32,4.1a29.34,29.34,0,0,1,8.09,8.6A40.53,40.53,0,0,1,3732.65,6340.45Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3605.47,6322.45h-39.32l1.64-35.76h34a101.38,101.38,0,0,1,2.54,11.6A108.54,108.54,0,0,1,3605.47,6322.45Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3625.31,6337.64h-59.16l.76-31.84a340.91,340.91,0,0,1,38.78,12.16q5.13,1.95,10.09,4a24.83,24.83,0,0,1,6.35,7.61A34.34,34.34,0,0,1,3625.31,6337.64Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3645,5874.57c0,9-13.86,20.33-28.36,20-12.23-.28-24.52-8.87-26-18-.68-4.11,1.4-4.76,1.8-14.79.33-8.22-1-10,.68-14.16,1.87-4.67,5.48-7.27,9.43-10.11,4.6-3.3,9-6.47,15.51-6.74a22.36,22.36,0,0,1,18.2,8.09,21.79,21.79,0,0,1,4,8.76c1.24,5.43-.39,7.45,0,12.81C3640.9,5868.48,3645,5869.69,3645,5874.57Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3643.56,5850.1c-7.95-2.7-16.62-4.2-21.32.11s-4.07,13.61-5.94,13.63-2.51-8.72-4.72-8.82-2.16,8.37-7.93,14.38a26.69,26.69,0,0,1-13,7.15c-.61-1.13-9.07-17.38-.8-31.71,7.34-12.71,22.32-14.34,31.46-15.34,8.37-.92,11.81.82,13,1.53C3643.05,5836,3643.52,5848.39,3643.56,5850.1Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3613.45,
    cy: 5862.65,
    rx: 9.85,
    ry: 4.8,
    transform: "translate(-6086.27 2893.55) rotate(-82.89)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3671.26,6062.89l-40.81,11.76a325.81,325.81,0,0,1-44.92-162.58c1.9-2.56,7.91-10,16.12-10,8,0,13.89,7.16,17.64,12.26,22,30,31.46,66.76,31.46,66.76C3660.51,6019.2,3667.35,6046.91,3671.26,6062.89Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3585.05,5939.54l-1.63,9.37a41.13,41.13,0,0,1-10.36,16.32c-13.9,13.2-38.43,16.43-45,7.55-4.65-6.31.76-17.42,5.75-27.69,3.09-6.36,12.13-24.27,31.1-31.11,5-1.79,11.6-4.17,16.53-1C3587.37,5916.85,3589,5927.49,3585.05,5939.54Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3871.58,6315.9l-10.2-7.32c-25.92-18.61-30.94-53.53-11.2-78l7.76-9.61c19.73-24.46,56.75-29.19,82.68-10.57l10.19,7.31c25.93,18.62,31,53.53,11.21,78l-7.76,9.61C3934.52,6329.78,3897.5,6334.51,3871.58,6315.9Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "538.6 453.74 447.47 499.32 397.87 410.36 488.99 364.78 538.6 453.74"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3910,6308.32l-15.56-1.29c-24.3-2-42.79-22.6-41.3-46l.95-15c1.49-23.37,22.39-40.68,46.69-38.66l15.56,1.29c24.3,2,42.79,22.6,41.3,46l-1,15C3955.19,6293,3934.29,6310.34,3910,6308.32Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3885.92,6314.9h0c-27.6-12.81-39.75-44.5-27.14-70.77h0c12.61-26.28,45.2-37.2,72.8-24.39h0c27.6,12.81,39.75,44.5,27.14,70.77h0C3946.11,6316.79,3913.51,6327.71,3885.92,6314.9Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3931.12,6297.88h0c-16.33,11.15-44.8,1.75-63.6-21h0c-18.79-22.75-20.79-50.23-4.46-61.38h0c16.32-11.15,44.8-1.75,63.59,21h0C3945.45,6259.25,3947.45,6286.73,3931.12,6297.88Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3832.67,6295.12h0c-3.59-8.9,25.21-30.07,64.33-47.27h0c39.12-17.21,73.74-23.93,77.33-15h0c3.59,8.91-25.22,30.07-64.33,47.28h0C3870.88,6297.3,3836.25,6304,3832.67,6295.12Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3949,6189.24l24.48,70.12q-17,9.11-34.14,18.06-18,9.39-36,18.61c17.74-13,21.4-31.24,15.62-37.78s-25.22-6.41-42,7.37a102,102,0,0,0,8.77-40.32c.05-12.21-.74-18.47,1.6-31.26a8.73,8.73,0,0,1,2.17-4.47c4.51-4.83,15.52-4.64,22.53.19a19.15,19.15,0,0,1,7.29,10.21c-5.77-8.5-19.81-28.3-25.6-26-5.61,2.23-5.18,25.8,7.07,33.47C3911.91,6214.42,3933.81,6208.9,3949,6189.24Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3957.52,6291.43h0c-20.43,7.94-47.79-6.74-61.11-32.8h0c-13.32-26.05-7.56-53.62,12.87-61.56h0c20.43-7.95,47.8,6.73,61.12,32.79h0C3983.72,6255.92,3978,6283.48,3957.52,6291.43Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3897.48,6325.83h0c-9.56-3.07-9-35,1.27-71.37h0c10.25-36.35,26.32-63.33,35.87-60.26h0c9.56,3.08,9,35-1.26,71.38h0C3923.1,6301.93,3907,6328.9,3897.48,6325.83Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3975.6,6283.71h0c-3.91,8.79-37.67,6.06-75.41-6.09h0c-37.74-12.14-65.18-29.11-61.27-37.89h0c3.9-8.79,37.66-6.06,75.41,6.09h0C3952.07,6258,3979.5,6274.93,3975.6,6283.71Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3943.37,6237.2q7.52,21.49,15,43-10.44,5.58-20.93,11.07-11,5.74-22.08,11.4c10.87-8,13.12-19.14,9.57-23.15s-15.45-3.94-25.71,4.51a62.42,62.42,0,0,0,5.37-24.71c0-10.05-2.52-16.3,1-19.16,2.32-1.89,7.42-2.39,19.61,3.64Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3908.12,6247.82q7.5,21.49,15,43-10.44,5.58-20.93,11.07-11,5.76-22.08,11.4c10.87-8,13.11-19.14,9.57-23.15s-15.46-3.93-25.71,4.52a62.52,62.52,0,0,0,5.37-24.72c0-10-2.53-16.3,1-19.16,2.32-1.89,7.42-2.39,19.61,3.64Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3938.92,6212q7.5,21.48,15,43-10.44,5.6-20.93,11.07-11,5.76-22.08,11.41c10.87-8,13.11-19.15,9.57-23.16s-15.46-3.93-25.72,4.52a62.45,62.45,0,0,0,5.38-24.71c0-10.05-2.53-16.31,1-19.16,2.31-1.89,7.42-2.4,19.61,3.63Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3881.42,
    cy: 6271.51,
    rx: 25.89,
    ry: 19.27,
    transform: "translate(-5373.76 -4087.87) rotate(-20.35)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3903.44,
    cy: 6253.92,
    rx: 22.84,
    ry: 31.92,
    transform: "translate(-5963.34 -3178.08) rotate(-28.77)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3889.32,
    cy: 6257.15,
    rx: 24.82,
    ry: 21.36,
    transform: "translate(-5018.77 -4503.98) rotate(-16.11)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3912.17,
    cy: 6267.04,
    rx: 16.21,
    ry: 11.1,
    transform: "translate(-5442.08 -3982.92) rotate(-21.27)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3843.83,6316.08q2.24-2.73,4.62-5.45a236,236,0,0,1,57.52-47.32",
    transform: "translate(-3434.95 -5829.24)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3890.74,6307.82c-.12,13-8.15,23.16-17.83,24.83-6.43,1.12-12-1.78-14.34-3.21",
    transform: "translate(-3434.95 -5829.24)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3824.58,6210.32a30.52,30.52,0,0,1,18.27-3.65,29.69,29.69,0,0,1,17.5,8.41",
    transform: "translate(-3434.95 -5829.24)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4174.2,6126.49c-2.82,48.35-7.91,113-17.79,189.4l-52.61,1.26c4.36-80.39,3.48-145.66,1.86-190.66-3.65-101-13.4-164,13.23-186.43,10.75-9.07,26.75-11,38.29-3C4171.94,5947.3,4183,5976.13,4174.2,6126.49Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 665.53,
    cy: 237.11,
    rx: 66.07,
    ry: 22.19
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 616.5,
    cy: 184.54,
    rx: 27.08,
    ry: 64.32
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 762.42,
    cy: 302.13,
    rx: 57.44,
    ry: 30.3
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 803.91,
    cy: 226.11,
    rx: 28.72,
    ry: 95.32
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3489.33,6313.88l-5-3.58c-12.7-9.12-15.16-26.23-5.49-38.2l3.8-4.71c9.67-12,27.8-14.3,40.5-5.18l5,3.58c12.7,9.12,15.16,26.23,5.49,38.21l-3.8,4.71C3520.17,6320.68,3502,6323,3489.33,6313.88Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "104.33 468.52 59.69 490.85 35.39 447.27 80.03 424.94 104.33 468.52"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3508.15,6310.17l-7.62-.63c-11.91-1-21-11.07-20.24-22.52l.47-7.33c.73-11.45,11-19.93,22.87-18.94l7.62.63c11.91,1,21,11.08,20.24,22.52l-.47,7.33C3530.29,6302.68,3520.05,6311.16,3508.15,6310.17Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3496.36,6313.39h0c-13.52-6.27-19.47-21.8-13.3-34.67h0c6.18-12.87,22.15-18.22,35.67-11.94h0c13.52,6.27,19.47,21.79,13.29,34.67h0C3525.84,6314.32,3509.88,6319.67,3496.36,6313.39Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3518.5,6305.06h0c-8,5.46-21.95.85-31.15-10.29h0c-9.21-11.14-10.19-24.61-2.19-30.07h0c8-5.46,22-.86,31.15,10.28h0C3525.52,6286.13,3526.5,6299.59,3518.5,6305.06Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3470.27,6303.71h0c-1.76-4.37,12.35-14.74,31.52-23.16h0c19.16-8.43,36.12-11.73,37.88-7.37h0c1.76,4.37-12.35,14.74-31.52,23.16h0C3489,6304.77,3472,6308.07,3470.27,6303.71Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3527.24,6251.84l12,34.35q-8.34,4.46-16.73,8.84-8.81,4.61-17.65,9.12c8.69-6.38,10.49-15.3,7.65-18.51s-12.35-3.14-20.55,3.61a49.87,49.87,0,0,0,4.29-19.75c0-6-.36-9.05.79-15.31a4.23,4.23,0,0,1,1.06-2.19c2.21-2.37,7.6-2.28,11,.09a9.41,9.41,0,0,1,3.57,5c-2.82-4.16-9.7-13.86-12.54-12.74s-2.54,12.64,3.46,16.4C3509.09,6264.17,3519.82,6261.46,3527.24,6251.84Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3531.44,6301.89h0c-10,3.9-23.42-3.3-29.94-16.06h0c-6.53-12.77-3.71-26.27,6.3-30.16h0c10-3.89,23.42,3.3,29.94,16.06h0C3544.27,6284.5,3541.44,6298,3531.44,6301.89Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3502,6318.75h0c-4.68-1.5-4.4-17.16.62-35h0c5-17.8,12.9-31,17.58-29.51h0c4.68,1.5,4.4,17.16-.62,35h0C3514.57,6307,3506.71,6320.25,3502,6318.75Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3540.29,6298.12h0c-1.91,4.3-18.45,3-36.94-3h0c-18.49-5.95-31.93-14.26-30-18.56h0c1.91-4.31,18.45-3,36.94,3h0C3528.76,6285.5,3542.2,6293.81,3540.29,6298.12Z",
    transform: "translate(-3434.95 -5829.24)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3498.72,6309.93c-.06,6.38-4,11.34-8.74,12.16a10.42,10.42,0,0,1-7-1.57",
    transform: "translate(-3434.95 -5829.24)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3466.31,6262.16a15,15,0,0,1,9-1.79,14.5,14.5,0,0,1,8.57,4.12",
    transform: "translate(-3434.95 -5829.24)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty1);
export default __webpack_public_path__ + "static/media/Empty1.7eb2dca9e714dbd1f9fd46deed217994.svg";
export { ForwardRef as ReactComponent };